<template>
    <main-content-layout
      :title="$gettext('CLIENT_UNIT')"
      :buttonTitle="$gettext('HISTORIC')"
      :actionButton="()=>{ showRouter() }"
      buttonIconName="list"
    >
      <div class="row" >
      <client-unit-card
        :data="consumerUnitClientData.consumerUnitOwner"
        :title="$gettext('OWNER')"
        :ownershipChange="false"
        @replace="replace"
        @edit="edit"
      />
      <client-unit-card
        :data="consumerUnitClientData.consumerUnitOccupier"
        :ownershipChange="false"
        :title="$gettext('RESIDENT_OR_OCCUPANT')"
        @replace="replace"
        @edit="edit"
      />
      <client-unit-card
        :data="consumerUnitClientData.consumerUnitInterested"
        :title="$gettext('INTERESTED_PERSON')"
        :ownershipChange="false"
        @replace="replace"
        @edit="edit"
      />

      <modal
        ref="editPersonModal"
        v-if="flModalShow"
        :show="flModalShow"
        :forms="formsModal"
        :label="$gettext('DEFINITION_OF_GROUPS')"
        @action-button="actionButton"
        maximized
      >
        <template slot="form">
          <person-page
            :forms="forms"
            :parent="this"
            @action-button="actionButton"
          />
        </template>
      </modal>
    </div>

    <jt-search-ownership-change-modal
      v-if="renderModal"
      :ownershipChangeForm="ownershipChangeForm"
      :ownershipChangeFilesForm="ownershipChangeFilesForm"
      :ownershipChangeDatesForm="ownershipChangeDatesForm"
      @on-close="closeModal"
      @on-save="onSaveOwnershipChange"
    />
    </main-content-layout>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequestController from '../../../ServiceRequestController'
import ServiceRequesClientUnitController from './ServiceRequesClientUnitController'
import ClientUnitCard from './ClientUnitCard.vue'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
import PersonPage from '../../../../../../modules/person/person/PersonPage.vue'
import JtSearchOwnershipChangeModal from '../../../../../consumer-unit/JtSearchOwnershipChangeModal.vue'
const { modal, page } = JtCrud
import MainContentLayout from '../../Layout/MainContentLayout.vue'

@Component({
  mixins: [page],
  name: 'ServiceRequestClientCard',
  components: {
    MainContentLayout,
    ClientUnitCard,
    modal,
    JtDynamicForm,
    JtSearchOwnershipChangeModal,
    PersonPage
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestClientCard extends Vue {
  controller = ServiceRequestController.getInstance();
  registrationInformationcontroller =
    ServiceRequesClientUnitController.getInstance();

  consumerUnitClientData = {};
  renderModal = false;
  ownershipChangeForm = null;
  ownershipChangeFilesForm = {};
  ownershipChangeDatesForm = {};

  forms = null;
  formsModal = null;
  flModalShow = false;
  personToEdit = null;
  async replace () {
    await this.initComponent()
    this.renderModal = true
    this.flModalShow = false
  }

  closeModal () {
    this.renderModal = false
  }

  edit (data) {
    this.personToEdit = data
    this.loadPerson(data)
  }

  showRouter () {
    this.controller.routerConsumerUnit(
      {
        name: 'serviceRequest.registration-information.client-card-history',
        params: {
          consumerUnit: this.consumerUnit,
          protocol: this.protocol
        }
      },
      this.protocol,
      this.consumerUnit
    )
  }

  async actionButton () {
    const result = await this.registrationInformationcontroller.saveCardClient(
      {
        id: this.personToEdit.id,
        ...this.forms[0].dadosForm
      },
      !!this.personToEdit.physicalPerson.id
    )

    await this.controller.getInfoCard(this.protocol, this.consumerUnit)
    if (result.messages[0].tipo == 'success') {
      this.loadCards()
    }
    this.flModalShow = false
  }

  async initComponent () {
    const { formOwnerOccupier, formFiles, formDates } =
      await this.registrationInformationcontroller.loadCadClient(
        this.consumerUnit
      )

    this.ownershipChangeForm = formOwnerOccupier[0]
    this.ownershipChangeForm.dadosForm = {
      newOwner: this.consumerUnitClientData.consumerUnitOwner.id,
      newOccupier: this.consumerUnitClientData.consumerUnitOccupier.id,
      oldOwner: this.consumerUnitClientData.consumerUnitOwner.id,
      oldOccupier: this.consumerUnitClientData.consumerUnitOccupier.id,
      consumerUnitClients: this.consumerUnitClientData.consumerUnitClients
    }
    this.ownershipChangeFilesForm = formFiles[0]
    this.ownershipChangeDatesForm = formDates[0]
  }

  loadPerson (data) {
    this.generatePersonForm(data)
    this.flModalShow = true
    this.renderModal = false
  }

  async generatePersonForm (data) {
    data.id = data.physicalPerson.id || data.legalEntity.id
    this.forms = await this.registrationInformationcontroller.resolveCardClient(
      data,
      !!data.physicalPerson.id
    )
    this.formsModal = JSON.parse(JSON.stringify(this.forms))
    this.forms[0].buttons = []
  }

  async loadCards () {
    this.consumerUnitClientData =
      await this.registrationInformationcontroller.loadCards(this.consumerUnit)
  }

  async onSaveOwnershipChange (data) {
    this.updateConsumerUnitClientData(data)
    const ownershipChangeData = this.getOwnershipChangeData(data)
    this.consumerUnitClientData.ownershipChangeData = ownershipChangeData
    this.updateInterestedConsumerUnit()

    await this.updateAndReloadData()
    this.closeModal()
  }

  updateConsumerUnitClientData (data) {
    if (data.datesData.dateRegisterType != 50020002) {
      this.consumerUnitClientData = {
        ...this.consumerUnitClientData,
        consumerUnitOwner: data.occupierAndOwnerData.newOwner,
        consumerUnitOccupier: data.occupierAndOwnerData.newOccupier
      }
    } else {
      this.consumerUnitClientData = {
        ...this.consumerUnitClientData,
        consumerUnitOwner: this.consumerUnitClientData.consumerUnitOwner.id,
        consumerUnitOccupier: this.consumerUnitClientData.consumerUnitOccupier.id
      }
    }
  }

  getOwnershipChangeData (data) {
    return [
      data.filesData,
      data.datesData,
      data.occupierAndOwnerData
    ]
  }

  updateInterestedConsumerUnit () {
    this.consumerUnitClientData.consumerUnitInterested =
    this.consumerUnitClientData.consumerUnitInterested.id
  }

  async updateAndReloadData () {
    try {
      await this.registrationInformationcontroller.updateConsumerUnit({
        ...this.consumerUnitClientData
      })
      await this.controller.getInfoCard(this.protocol, this.consumerUnit)
      await this.loadCards()
      await this.initComponent()
    } catch (error) {
      console.error('Error updating data:', error)
    }
  }

  async mounted () {
    await this.loadCards()
    await this.initComponent()
  }
}
export default ServiceRequestClientCard
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

h6 {
  font-size: 20px;
  margin: 3px 20px;
  color: $light-d;
}

.layout {
  height: 700px;
  background-color: $off-white;
}
</style>
